/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.

export type CreateClientInput = {
  id?: string | null,
  ownerUserId: string,
  name: string,
  slug: string,
  inviteLink?: string | null,
  userRole?: string | null,
  defaultWorkspaces?: string | null,
  meta: string,
  created_at?: string | null,
  customer_id?: string | null,
  subscription_plan?: string | null,
  subscription_status?: string | null,
  subscription_endsAt?: string | null,
  subscription_details?: string | null,
  _version?: number | null,
};

export type ModelClientConditionInput = {
  ownerUserId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  inviteLink?: ModelStringInput | null,
  userRole?: ModelStringInput | null,
  defaultWorkspaces?: ModelStringInput | null,
  meta?: ModelStringInput | null,
  created_at?: ModelStringInput | null,
  customer_id?: ModelStringInput | null,
  subscription_plan?: ModelStringInput | null,
  subscription_status?: ModelStringInput | null,
  subscription_endsAt?: ModelStringInput | null,
  subscription_details?: ModelStringInput | null,
  and?: Array< ModelClientConditionInput | null > | null,
  or?: Array< ModelClientConditionInput | null > | null,
  not?: ModelClientConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  id?: ModelStringInput | null,
};

export type ModelIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null",
}


export type ModelSizeInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
};

export type ModelStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
  size?: ModelSizeInput | null,
};

export type ModelBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Client = {
  __typename: "Client",
  id: string,
  ownerUserId: string,
  name: string,
  slug: string,
  inviteLink?: string | null,
  userRole?: string | null,
  defaultWorkspaces?: string | null,
  meta: string,
  created_at?: string | null,
  customer_id?: string | null,
  subscription_plan?: string | null,
  subscription_status?: string | null,
  subscription_endsAt?: string | null,
  subscription_details?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateClientInput = {
  id: string,
  ownerUserId?: string | null,
  name?: string | null,
  slug?: string | null,
  inviteLink?: string | null,
  userRole?: string | null,
  defaultWorkspaces?: string | null,
  meta?: string | null,
  created_at?: string | null,
  customer_id?: string | null,
  subscription_plan?: string | null,
  subscription_status?: string | null,
  subscription_endsAt?: string | null,
  subscription_details?: string | null,
  _version?: number | null,
};

export type DeleteClientInput = {
  id: string,
  _version?: number | null,
};

export type CreateClientUserInput = {
  ownerId: string,
  id?: string | null,
  email: string,
  sub: string,
  name?: string | null,
  surname?: string | null,
  isAdmin: boolean,
  isReadOnly: boolean,
  roles: string,
  roleUpdatedBy?: string | null,
  isConfirmed?: boolean | null,
  avatarPath?: string | null,
  closedAt?: string | null,
  lastActive?: string | null,
  _version?: number | null,
};

export type ModelClientUserConditionInput = {
  ownerId?: ModelIDInput | null,
  email?: ModelStringInput | null,
  sub?: ModelStringInput | null,
  name?: ModelStringInput | null,
  surname?: ModelStringInput | null,
  isAdmin?: ModelBooleanInput | null,
  isReadOnly?: ModelBooleanInput | null,
  roles?: ModelStringInput | null,
  roleUpdatedBy?: ModelStringInput | null,
  isConfirmed?: ModelBooleanInput | null,
  avatarPath?: ModelStringInput | null,
  closedAt?: ModelStringInput | null,
  lastActive?: ModelStringInput | null,
  and?: Array< ModelClientUserConditionInput | null > | null,
  or?: Array< ModelClientUserConditionInput | null > | null,
  not?: ModelClientUserConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ClientUser = {
  __typename: "ClientUser",
  ownerId: string,
  id: string,
  email: string,
  sub: string,
  name?: string | null,
  surname?: string | null,
  isAdmin: boolean,
  isReadOnly: boolean,
  roles: string,
  roleUpdatedBy?: string | null,
  isConfirmed?: boolean | null,
  avatarPath?: string | null,
  closedAt?: string | null,
  lastActive?: string | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateClientUserInput = {
  ownerId?: string | null,
  id: string,
  email?: string | null,
  sub?: string | null,
  name?: string | null,
  surname?: string | null,
  isAdmin?: boolean | null,
  isReadOnly?: boolean | null,
  roles?: string | null,
  roleUpdatedBy?: string | null,
  isConfirmed?: boolean | null,
  avatarPath?: string | null,
  closedAt?: string | null,
  lastActive?: string | null,
  _version?: number | null,
};

export type DeleteClientUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateClientUserInviteInput = {
  ownerId: string,
  id?: string | null,
  email: string,
  isAdmin: boolean,
  isReadOnly: boolean,
  roles: string,
  isInviteConfirmed: boolean,
  inviteLink: string,
  _version?: number | null,
};

export type ModelClientUserInviteConditionInput = {
  ownerId?: ModelIDInput | null,
  email?: ModelStringInput | null,
  isAdmin?: ModelBooleanInput | null,
  isReadOnly?: ModelBooleanInput | null,
  roles?: ModelStringInput | null,
  isInviteConfirmed?: ModelBooleanInput | null,
  inviteLink?: ModelStringInput | null,
  and?: Array< ModelClientUserInviteConditionInput | null > | null,
  or?: Array< ModelClientUserInviteConditionInput | null > | null,
  not?: ModelClientUserInviteConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
};

export type ClientUserInvite = {
  __typename: "ClientUserInvite",
  ownerId: string,
  id: string,
  email: string,
  isAdmin: boolean,
  isReadOnly: boolean,
  roles: string,
  isInviteConfirmed: boolean,
  inviteLink: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateClientUserInviteInput = {
  ownerId?: string | null,
  id: string,
  email?: string | null,
  isAdmin?: boolean | null,
  isReadOnly?: boolean | null,
  roles?: string | null,
  isInviteConfirmed?: boolean | null,
  inviteLink?: string | null,
  _version?: number | null,
};

export type DeleteClientUserInviteInput = {
  id: string,
  _version?: number | null,
};

export type CreateWorkspaceInput = {
  ownerId: string,
  id?: string | null,
  name?: string | null,
  slug?: string | null,
  avatarPath?: string | null,
  childIds: string,
  archivedIds: string,
  trashedIds: string,
  pinnedIds?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelWorkspaceConditionInput = {
  ownerId?: ModelStringInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  avatarPath?: ModelStringInput | null,
  childIds?: ModelStringInput | null,
  archivedIds?: ModelStringInput | null,
  trashedIds?: ModelStringInput | null,
  pinnedIds?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelWorkspaceConditionInput | null > | null,
  or?: Array< ModelWorkspaceConditionInput | null > | null,
  not?: ModelWorkspaceConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type Workspace = {
  __typename: "Workspace",
  ownerId: string,
  id: string,
  name?: string | null,
  slug?: string | null,
  avatarPath?: string | null,
  childIds: string,
  archivedIds: string,
  trashedIds: string,
  pinnedIds?: string | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWorkspaceInput = {
  ownerId?: string | null,
  id: string,
  name?: string | null,
  slug?: string | null,
  avatarPath?: string | null,
  childIds?: string | null,
  archivedIds?: string | null,
  trashedIds?: string | null,
  pinnedIds?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteWorkspaceInput = {
  id: string,
  _version?: number | null,
};

export type CreateWorkspaceUserInput = {
  ownerId: string,
  workspaceId: string,
  userId: string,
  role: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  createdBy?: string | null,
  updatedBy?: string | null,
  id?: string | null,
  _version?: number | null,
};

export type ModelWorkspaceUserConditionInput = {
  ownerId?: ModelIDInput | null,
  workspaceId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  role?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  and?: Array< ModelWorkspaceUserConditionInput | null > | null,
  or?: Array< ModelWorkspaceUserConditionInput | null > | null,
  not?: ModelWorkspaceUserConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type WorkspaceUser = {
  __typename: "WorkspaceUser",
  ownerId: string,
  workspaceId: string,
  userId: string,
  role: string,
  createdAt?: string | null,
  updatedAt?: string | null,
  createdBy?: string | null,
  updatedBy?: string | null,
  id: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateWorkspaceUserInput = {
  ownerId?: string | null,
  workspaceId?: string | null,
  userId?: string | null,
  role?: string | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  createdBy?: string | null,
  updatedBy?: string | null,
  id: string,
  _version?: number | null,
};

export type DeleteWorkspaceUserInput = {
  id: string,
  _version?: number | null,
};

export type CreateItemInput = {
  ownerId: string,
  workspaceId: string,
  id?: string | null,
  name?: string | null,
  type: ItemType,
  childIds: string,
  parentIds: string,
  readRoles: string,
  writeRoles: string,
  creator: string,
  pinned?: boolean | null,
  trashed: boolean,
  archived: boolean,
  statusUpdatedBy?: string | null,
  ackUpdatedBy?: string | null,
  acknowledgementRequired?: boolean | null,
  acknowledgement?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export enum ItemType {
  LEAF = "LEAF",
  CLUSTER = "CLUSTER",
}


export type ModelItemConditionInput = {
  ownerId?: ModelStringInput | null,
  workspaceId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelItemTypeInput | null,
  childIds?: ModelStringInput | null,
  parentIds?: ModelStringInput | null,
  readRoles?: ModelStringInput | null,
  writeRoles?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  pinned?: ModelBooleanInput | null,
  trashed?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  statusUpdatedBy?: ModelStringInput | null,
  ackUpdatedBy?: ModelStringInput | null,
  acknowledgementRequired?: ModelBooleanInput | null,
  acknowledgement?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelItemConditionInput | null > | null,
  or?: Array< ModelItemConditionInput | null > | null,
  not?: ModelItemConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
};

export type ModelItemTypeInput = {
  eq?: ItemType | null,
  ne?: ItemType | null,
};

export type Item = {
  __typename: "Item",
  ownerId: string,
  workspaceId: string,
  id: string,
  name?: string | null,
  type: ItemType,
  childIds: string,
  parentIds: string,
  readRoles: string,
  writeRoles: string,
  creator: string,
  pinned?: boolean | null,
  trashed: boolean,
  archived: boolean,
  statusUpdatedBy?: string | null,
  ackUpdatedBy?: string | null,
  acknowledgementRequired?: boolean | null,
  acknowledgement?: string | null,
  updatedAt: string,
  createdAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateItemInput = {
  ownerId?: string | null,
  workspaceId?: string | null,
  id: string,
  name?: string | null,
  type?: ItemType | null,
  childIds?: string | null,
  parentIds?: string | null,
  readRoles?: string | null,
  writeRoles?: string | null,
  creator?: string | null,
  pinned?: boolean | null,
  trashed?: boolean | null,
  archived?: boolean | null,
  statusUpdatedBy?: string | null,
  ackUpdatedBy?: string | null,
  acknowledgementRequired?: boolean | null,
  acknowledgement?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteItemInput = {
  id: string,
  _version?: number | null,
};

export type CreateEventInput = {
  id?: string | null,
  ownerId: string,
  workspaceId?: string | null,
  initiatorId?: string | null,
  type: string,
  meta: string,
  createdAt?: string | null,
  _version?: number | null,
};

export type ModelEventConditionInput = {
  ownerId?: ModelIDInput | null,
  workspaceId?: ModelStringInput | null,
  initiatorId?: ModelIDInput | null,
  type?: ModelStringInput | null,
  meta?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelEventConditionInput | null > | null,
  or?: Array< ModelEventConditionInput | null > | null,
  not?: ModelEventConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Event = {
  __typename: "Event",
  id: string,
  ownerId: string,
  workspaceId?: string | null,
  initiatorId?: string | null,
  type: string,
  meta: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateEventInput = {
  id: string,
  ownerId?: string | null,
  workspaceId?: string | null,
  initiatorId?: string | null,
  type?: string | null,
  meta?: string | null,
  createdAt?: string | null,
  _version?: number | null,
};

export type DeleteEventInput = {
  id: string,
  _version?: number | null,
};

export type CreateNotificationInput = {
  id?: string | null,
  ownerId: string,
  userId: string,
  eventId?: string | null,
  status?: string | null,
  channelAttempts?: string | null,
  initiatorId?: string | null,
  type: string,
  meta: string,
  createdAt?: string | null,
  _version?: number | null,
};

export type ModelNotificationConditionInput = {
  ownerId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  channelAttempts?: ModelStringInput | null,
  initiatorId?: ModelIDInput | null,
  type?: ModelStringInput | null,
  meta?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelNotificationConditionInput | null > | null,
  or?: Array< ModelNotificationConditionInput | null > | null,
  not?: ModelNotificationConditionInput | null,
  _deleted?: ModelBooleanInput | null,
  updatedAt?: ModelStringInput | null,
};

export type Notification = {
  __typename: "Notification",
  id: string,
  ownerId: string,
  userId: string,
  eventId?: string | null,
  status?: string | null,
  channelAttempts?: string | null,
  initiatorId?: string | null,
  type: string,
  meta: string,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateNotificationInput = {
  id: string,
  ownerId?: string | null,
  userId?: string | null,
  eventId?: string | null,
  status?: string | null,
  channelAttempts?: string | null,
  initiatorId?: string | null,
  type?: string | null,
  meta?: string | null,
  createdAt?: string | null,
  _version?: number | null,
};

export type DeleteNotificationInput = {
  id: string,
  _version?: number | null,
};

export type CreateDocumentInput = {
  ownerId: string,
  id?: string | null,
  docVersion: number,
  content: string,
  latestEditor: string,
  trashed?: boolean | null,
  archived?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type ModelDocumentConditionInput = {
  ownerId?: ModelStringInput | null,
  docVersion?: ModelIntInput | null,
  content?: ModelStringInput | null,
  latestEditor?: ModelStringInput | null,
  trashed?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentConditionInput | null > | null,
  or?: Array< ModelDocumentConditionInput | null > | null,
  not?: ModelDocumentConditionInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelIntInput = {
  ne?: number | null,
  eq?: number | null,
  le?: number | null,
  lt?: number | null,
  ge?: number | null,
  gt?: number | null,
  between?: Array< number | null > | null,
  attributeExists?: boolean | null,
  attributeType?: ModelAttributeTypes | null,
};

export type Document = {
  __typename: "Document",
  ownerId: string,
  id: string,
  docVersion: number,
  content: string,
  latestEditor: string,
  trashed?: boolean | null,
  archived?: boolean | null,
  createdAt: string,
  updatedAt: string,
  _version: number,
  _deleted?: boolean | null,
  _lastChangedAt: number,
};

export type UpdateDocumentInput = {
  ownerId?: string | null,
  id: string,
  docVersion?: number | null,
  content?: string | null,
  latestEditor?: string | null,
  trashed?: boolean | null,
  archived?: boolean | null,
  createdAt?: string | null,
  updatedAt?: string | null,
  _version?: number | null,
};

export type DeleteDocumentInput = {
  id: string,
  _version?: number | null,
};

export type ModelClientFilterInput = {
  id?: ModelIDInput | null,
  ownerUserId?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  inviteLink?: ModelStringInput | null,
  userRole?: ModelStringInput | null,
  defaultWorkspaces?: ModelStringInput | null,
  meta?: ModelStringInput | null,
  created_at?: ModelStringInput | null,
  customer_id?: ModelStringInput | null,
  subscription_plan?: ModelStringInput | null,
  subscription_status?: ModelStringInput | null,
  subscription_endsAt?: ModelStringInput | null,
  subscription_details?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientFilterInput | null > | null,
  or?: Array< ModelClientFilterInput | null > | null,
  not?: ModelClientFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export enum ModelSortDirection {
  ASC = "ASC",
  DESC = "DESC",
}


export type ModelClientConnection = {
  __typename: "ModelClientConnection",
  items:  Array<Client | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelClientUserFilterInput = {
  ownerId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  sub?: ModelStringInput | null,
  name?: ModelStringInput | null,
  surname?: ModelStringInput | null,
  isAdmin?: ModelBooleanInput | null,
  isReadOnly?: ModelBooleanInput | null,
  roles?: ModelStringInput | null,
  roleUpdatedBy?: ModelStringInput | null,
  isConfirmed?: ModelBooleanInput | null,
  avatarPath?: ModelStringInput | null,
  closedAt?: ModelStringInput | null,
  lastActive?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientUserFilterInput | null > | null,
  or?: Array< ModelClientUserFilterInput | null > | null,
  not?: ModelClientUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelClientUserConnection = {
  __typename: "ModelClientUserConnection",
  items:  Array<ClientUser | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelClientUserInviteFilterInput = {
  ownerId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  email?: ModelStringInput | null,
  isAdmin?: ModelBooleanInput | null,
  isReadOnly?: ModelBooleanInput | null,
  roles?: ModelStringInput | null,
  isInviteConfirmed?: ModelBooleanInput | null,
  inviteLink?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelClientUserInviteFilterInput | null > | null,
  or?: Array< ModelClientUserInviteFilterInput | null > | null,
  not?: ModelClientUserInviteFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelClientUserInviteConnection = {
  __typename: "ModelClientUserInviteConnection",
  items:  Array<ClientUserInvite | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkspaceFilterInput = {
  ownerId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  slug?: ModelStringInput | null,
  avatarPath?: ModelStringInput | null,
  childIds?: ModelStringInput | null,
  archivedIds?: ModelStringInput | null,
  trashedIds?: ModelStringInput | null,
  pinnedIds?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelWorkspaceFilterInput | null > | null,
  or?: Array< ModelWorkspaceFilterInput | null > | null,
  not?: ModelWorkspaceFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWorkspaceConnection = {
  __typename: "ModelWorkspaceConnection",
  items:  Array<Workspace | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkspaceUserFilterInput = {
  ownerId?: ModelIDInput | null,
  workspaceId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  role?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdBy?: ModelStringInput | null,
  updatedBy?: ModelStringInput | null,
  id?: ModelIDInput | null,
  and?: Array< ModelWorkspaceUserFilterInput | null > | null,
  or?: Array< ModelWorkspaceUserFilterInput | null > | null,
  not?: ModelWorkspaceUserFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelWorkspaceUserConnection = {
  __typename: "ModelWorkspaceUserConnection",
  items:  Array<WorkspaceUser | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelWorkspaceUserByWorkspaceCompositeKeyConditionInput = {
  eq?: ModelWorkspaceUserByWorkspaceCompositeKeyInput | null,
  le?: ModelWorkspaceUserByWorkspaceCompositeKeyInput | null,
  lt?: ModelWorkspaceUserByWorkspaceCompositeKeyInput | null,
  ge?: ModelWorkspaceUserByWorkspaceCompositeKeyInput | null,
  gt?: ModelWorkspaceUserByWorkspaceCompositeKeyInput | null,
  between?: Array< ModelWorkspaceUserByWorkspaceCompositeKeyInput | null > | null,
  beginsWith?: ModelWorkspaceUserByWorkspaceCompositeKeyInput | null,
};

export type ModelWorkspaceUserByWorkspaceCompositeKeyInput = {
  workspaceId?: string | null,
  userId?: string | null,
};

export type ModelIDKeyConditionInput = {
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
};

export type ModelItemFilterInput = {
  ownerId?: ModelStringInput | null,
  workspaceId?: ModelIDInput | null,
  id?: ModelIDInput | null,
  name?: ModelStringInput | null,
  type?: ModelItemTypeInput | null,
  childIds?: ModelStringInput | null,
  parentIds?: ModelStringInput | null,
  readRoles?: ModelStringInput | null,
  writeRoles?: ModelStringInput | null,
  creator?: ModelStringInput | null,
  pinned?: ModelBooleanInput | null,
  trashed?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  statusUpdatedBy?: ModelStringInput | null,
  ackUpdatedBy?: ModelStringInput | null,
  acknowledgementRequired?: ModelBooleanInput | null,
  acknowledgement?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  and?: Array< ModelItemFilterInput | null > | null,
  or?: Array< ModelItemFilterInput | null > | null,
  not?: ModelItemFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelItemConnection = {
  __typename: "ModelItemConnection",
  items:  Array<Item | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelEventFilterInput = {
  id?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  workspaceId?: ModelStringInput | null,
  initiatorId?: ModelIDInput | null,
  type?: ModelStringInput | null,
  meta?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelEventFilterInput | null > | null,
  or?: Array< ModelEventFilterInput | null > | null,
  not?: ModelEventFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelEventConnection = {
  __typename: "ModelEventConnection",
  items:  Array<Event | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelNotificationFilterInput = {
  id?: ModelIDInput | null,
  ownerId?: ModelIDInput | null,
  userId?: ModelIDInput | null,
  eventId?: ModelIDInput | null,
  status?: ModelStringInput | null,
  channelAttempts?: ModelStringInput | null,
  initiatorId?: ModelIDInput | null,
  type?: ModelStringInput | null,
  meta?: ModelStringInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelNotificationFilterInput | null > | null,
  or?: Array< ModelNotificationFilterInput | null > | null,
  not?: ModelNotificationFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelNotificationConnection = {
  __typename: "ModelNotificationConnection",
  items:  Array<Notification | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type ModelNotificationByClientCompositeKeyConditionInput = {
  eq?: ModelNotificationByClientCompositeKeyInput | null,
  le?: ModelNotificationByClientCompositeKeyInput | null,
  lt?: ModelNotificationByClientCompositeKeyInput | null,
  ge?: ModelNotificationByClientCompositeKeyInput | null,
  gt?: ModelNotificationByClientCompositeKeyInput | null,
  between?: Array< ModelNotificationByClientCompositeKeyInput | null > | null,
  beginsWith?: ModelNotificationByClientCompositeKeyInput | null,
};

export type ModelNotificationByClientCompositeKeyInput = {
  userId?: string | null,
  createdAt?: string | null,
};

export type ModelDocumentFilterInput = {
  ownerId?: ModelStringInput | null,
  id?: ModelIDInput | null,
  docVersion?: ModelIntInput | null,
  content?: ModelStringInput | null,
  latestEditor?: ModelStringInput | null,
  trashed?: ModelBooleanInput | null,
  archived?: ModelBooleanInput | null,
  createdAt?: ModelStringInput | null,
  updatedAt?: ModelStringInput | null,
  and?: Array< ModelDocumentFilterInput | null > | null,
  or?: Array< ModelDocumentFilterInput | null > | null,
  not?: ModelDocumentFilterInput | null,
  _deleted?: ModelBooleanInput | null,
};

export type ModelDocumentConnection = {
  __typename: "ModelDocumentConnection",
  items:  Array<Document | null >,
  nextToken?: string | null,
  startedAt?: number | null,
};

export type SearchableDocumentFilterInput = {
  ownerId?: SearchableStringFilterInput | null,
  id?: SearchableIDFilterInput | null,
  docVersion?: SearchableIntFilterInput | null,
  content?: SearchableStringFilterInput | null,
  latestEditor?: SearchableStringFilterInput | null,
  trashed?: SearchableBooleanFilterInput | null,
  archived?: SearchableBooleanFilterInput | null,
  createdAt?: SearchableStringFilterInput | null,
  updatedAt?: SearchableStringFilterInput | null,
  _version?: SearchableIntFilterInput | null,
  _deleted?: SearchableBooleanFilterInput | null,
  _lastChangedAt?: SearchableIntFilterInput | null,
  and?: Array< SearchableDocumentFilterInput | null > | null,
  or?: Array< SearchableDocumentFilterInput | null > | null,
  not?: SearchableDocumentFilterInput | null,
};

export type SearchableStringFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIDFilterInput = {
  ne?: string | null,
  gt?: string | null,
  lt?: string | null,
  gte?: string | null,
  lte?: string | null,
  eq?: string | null,
  match?: string | null,
  matchPhrase?: string | null,
  matchPhrasePrefix?: string | null,
  multiMatch?: string | null,
  exists?: boolean | null,
  wildcard?: string | null,
  regexp?: string | null,
  range?: Array< string | null > | null,
};

export type SearchableIntFilterInput = {
  ne?: number | null,
  gt?: number | null,
  lt?: number | null,
  gte?: number | null,
  lte?: number | null,
  eq?: number | null,
  range?: Array< number | null > | null,
};

export type SearchableBooleanFilterInput = {
  eq?: boolean | null,
  ne?: boolean | null,
};

export type SearchableDocumentSortInput = {
  field?: SearchableDocumentSortableFields | null,
  direction?: SearchableSortDirection | null,
};

export enum SearchableDocumentSortableFields {
  ownerId = "ownerId",
  id = "id",
  docVersion = "docVersion",
  content = "content",
  latestEditor = "latestEditor",
  trashed = "trashed",
  archived = "archived",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  _version = "_version",
  _deleted = "_deleted",
  _lastChangedAt = "_lastChangedAt",
}


export enum SearchableSortDirection {
  asc = "asc",
  desc = "desc",
}


export type SearchableDocumentAggregationInput = {
  name: string,
  type: SearchableAggregateType,
  field: SearchableDocumentAggregateField,
};

export enum SearchableAggregateType {
  terms = "terms",
  avg = "avg",
  min = "min",
  max = "max",
  sum = "sum",
  cardinality = "cardinality",
}


export enum SearchableDocumentAggregateField {
  ownerId = "ownerId",
  id = "id",
  docVersion = "docVersion",
  content = "content",
  latestEditor = "latestEditor",
  trashed = "trashed",
  archived = "archived",
  createdAt = "createdAt",
  updatedAt = "updatedAt",
  _version = "_version",
  _deleted = "_deleted",
  _lastChangedAt = "_lastChangedAt",
}


export type SearchableDocumentConnection = {
  __typename: "SearchableDocumentConnection",
  items:  Array<SearchDocument | null >,
  nextToken?: string | null,
  total?: number | null,
  aggregateItems:  Array<SearchableAggregateResult | null >,
};

export type SearchDocument = {
  __typename: "SearchDocument",
  ownerId?: string | null,
  id?: string | null,
  itemId?: string | null,
  docVersion?: number | null,
  trashed?: boolean | null,
  archived?: boolean | null,
  highlight?: Highlight | null,
  latestEditor?: string | null,
};

export type Highlight = {
  __typename: "Highlight",
  content?: Array< string | null > | null,
};

export type SearchableAggregateResult = {
  __typename: "SearchableAggregateResult",
  name: string,
  result?: SearchableAggregateGenericResult | null,
};

export type SearchableAggregateGenericResult = SearchableAggregateScalarResult | SearchableAggregateBucketResult


export type SearchableAggregateScalarResult = {
  __typename: "SearchableAggregateScalarResult",
  value: number,
};

export type SearchableAggregateBucketResult = {
  __typename: "SearchableAggregateBucketResult",
  buckets?:  Array<SearchableAggregateBucketResultItem | null > | null,
};

export type SearchableAggregateBucketResultItem = {
  __typename: "SearchableAggregateBucketResultItem",
  key: string,
  doc_count: number,
};

export type ModelSubscriptionClientFilterInput = {
  ownerUserId?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  inviteLink?: ModelSubscriptionStringInput | null,
  userRole?: ModelSubscriptionStringInput | null,
  defaultWorkspaces?: ModelSubscriptionStringInput | null,
  meta?: ModelSubscriptionStringInput | null,
  created_at?: ModelSubscriptionStringInput | null,
  customer_id?: ModelSubscriptionStringInput | null,
  subscription_plan?: ModelSubscriptionStringInput | null,
  subscription_status?: ModelSubscriptionStringInput | null,
  subscription_endsAt?: ModelSubscriptionStringInput | null,
  subscription_details?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  id?: ModelStringInput | null,
};

export type ModelSubscriptionIDInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionStringInput = {
  ne?: string | null,
  eq?: string | null,
  le?: string | null,
  lt?: string | null,
  ge?: string | null,
  gt?: string | null,
  contains?: string | null,
  notContains?: string | null,
  between?: Array< string | null > | null,
  beginsWith?: string | null,
  in?: Array< string | null > | null,
  notIn?: Array< string | null > | null,
};

export type ModelSubscriptionClientUserFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionStringInput | null,
  sub?: ModelSubscriptionStringInput | null,
  name?: ModelSubscriptionStringInput | null,
  surname?: ModelSubscriptionStringInput | null,
  isAdmin?: ModelSubscriptionBooleanInput | null,
  isReadOnly?: ModelSubscriptionBooleanInput | null,
  roles?: ModelSubscriptionStringInput | null,
  roleUpdatedBy?: ModelSubscriptionStringInput | null,
  isConfirmed?: ModelSubscriptionBooleanInput | null,
  avatarPath?: ModelSubscriptionStringInput | null,
  closedAt?: ModelSubscriptionStringInput | null,
  lastActive?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientUserFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type ModelSubscriptionBooleanInput = {
  ne?: boolean | null,
  eq?: boolean | null,
};

export type ModelSubscriptionClientUserInviteFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  email?: ModelSubscriptionStringInput | null,
  isAdmin?: ModelSubscriptionBooleanInput | null,
  isReadOnly?: ModelSubscriptionBooleanInput | null,
  roles?: ModelSubscriptionStringInput | null,
  isInviteConfirmed?: ModelSubscriptionBooleanInput | null,
  inviteLink?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionClientUserInviteFilterInput | null > | null,
  or?: Array< ModelSubscriptionClientUserInviteFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type ModelSubscriptionWorkspaceFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  slug?: ModelSubscriptionStringInput | null,
  avatarPath?: ModelSubscriptionStringInput | null,
  childIds?: ModelSubscriptionStringInput | null,
  archivedIds?: ModelSubscriptionStringInput | null,
  trashedIds?: ModelSubscriptionStringInput | null,
  pinnedIds?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionWorkspaceFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkspaceFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type ModelSubscriptionWorkspaceUserFilterInput = {
  workspaceId?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  role?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdBy?: ModelSubscriptionStringInput | null,
  updatedBy?: ModelSubscriptionStringInput | null,
  id?: ModelSubscriptionIDInput | null,
  and?: Array< ModelSubscriptionWorkspaceUserFilterInput | null > | null,
  or?: Array< ModelSubscriptionWorkspaceUserFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type ModelSubscriptionItemFilterInput = {
  workspaceId?: ModelSubscriptionIDInput | null,
  id?: ModelSubscriptionIDInput | null,
  name?: ModelSubscriptionStringInput | null,
  type?: ModelSubscriptionStringInput | null,
  childIds?: ModelSubscriptionStringInput | null,
  parentIds?: ModelSubscriptionStringInput | null,
  readRoles?: ModelSubscriptionStringInput | null,
  writeRoles?: ModelSubscriptionStringInput | null,
  creator?: ModelSubscriptionStringInput | null,
  pinned?: ModelSubscriptionBooleanInput | null,
  trashed?: ModelSubscriptionBooleanInput | null,
  archived?: ModelSubscriptionBooleanInput | null,
  statusUpdatedBy?: ModelSubscriptionStringInput | null,
  ackUpdatedBy?: ModelSubscriptionStringInput | null,
  acknowledgementRequired?: ModelSubscriptionBooleanInput | null,
  acknowledgement?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionItemFilterInput | null > | null,
  or?: Array< ModelSubscriptionItemFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type ModelSubscriptionEventFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  workspaceId?: ModelSubscriptionStringInput | null,
  initiatorId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  meta?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionEventFilterInput | null > | null,
  or?: Array< ModelSubscriptionEventFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type ModelSubscriptionNotificationFilterInput = {
  id?: ModelSubscriptionIDInput | null,
  userId?: ModelSubscriptionIDInput | null,
  eventId?: ModelSubscriptionIDInput | null,
  status?: ModelSubscriptionStringInput | null,
  channelAttempts?: ModelSubscriptionStringInput | null,
  initiatorId?: ModelSubscriptionIDInput | null,
  type?: ModelSubscriptionStringInput | null,
  meta?: ModelSubscriptionStringInput | null,
  createdAt?: ModelSubscriptionStringInput | null,
  updatedAt?: ModelSubscriptionStringInput | null,
  and?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
  or?: Array< ModelSubscriptionNotificationFilterInput | null > | null,
  _deleted?: ModelBooleanInput | null,
  ownerId?: ModelStringInput | null,
};

export type CreateClientMutationVariables = {
  input: CreateClientInput,
  condition?: ModelClientConditionInput | null,
};

export type CreateClientMutation = {
  createClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateClientMutationVariables = {
  input: UpdateClientInput,
  condition?: ModelClientConditionInput | null,
};

export type UpdateClientMutation = {
  updateClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteClientMutationVariables = {
  input: DeleteClientInput,
  condition?: ModelClientConditionInput | null,
};

export type DeleteClientMutation = {
  deleteClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateClientUserMutationVariables = {
  input: CreateClientUserInput,
  condition?: ModelClientUserConditionInput | null,
};

export type CreateClientUserMutation = {
  createClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateClientUserMutationVariables = {
  input: UpdateClientUserInput,
  condition?: ModelClientUserConditionInput | null,
};

export type UpdateClientUserMutation = {
  updateClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteClientUserMutationVariables = {
  input: DeleteClientUserInput,
  condition?: ModelClientUserConditionInput | null,
};

export type DeleteClientUserMutation = {
  deleteClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateClientUserInviteMutationVariables = {
  input: CreateClientUserInviteInput,
  condition?: ModelClientUserInviteConditionInput | null,
};

export type CreateClientUserInviteMutation = {
  createClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateClientUserInviteMutationVariables = {
  input: UpdateClientUserInviteInput,
  condition?: ModelClientUserInviteConditionInput | null,
};

export type UpdateClientUserInviteMutation = {
  updateClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteClientUserInviteMutationVariables = {
  input: DeleteClientUserInviteInput,
  condition?: ModelClientUserInviteConditionInput | null,
};

export type DeleteClientUserInviteMutation = {
  deleteClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateWorkspaceMutationVariables = {
  input: CreateWorkspaceInput,
  condition?: ModelWorkspaceConditionInput | null,
};

export type CreateWorkspaceMutation = {
  createWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWorkspaceMutationVariables = {
  input: UpdateWorkspaceInput,
  condition?: ModelWorkspaceConditionInput | null,
};

export type UpdateWorkspaceMutation = {
  updateWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWorkspaceMutationVariables = {
  input: DeleteWorkspaceInput,
  condition?: ModelWorkspaceConditionInput | null,
};

export type DeleteWorkspaceMutation = {
  deleteWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateWorkspaceUserMutationVariables = {
  input: CreateWorkspaceUserInput,
  condition?: ModelWorkspaceUserConditionInput | null,
};

export type CreateWorkspaceUserMutation = {
  createWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateWorkspaceUserMutationVariables = {
  input: UpdateWorkspaceUserInput,
  condition?: ModelWorkspaceUserConditionInput | null,
};

export type UpdateWorkspaceUserMutation = {
  updateWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteWorkspaceUserMutationVariables = {
  input: DeleteWorkspaceUserInput,
  condition?: ModelWorkspaceUserConditionInput | null,
};

export type DeleteWorkspaceUserMutation = {
  deleteWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateItemMutationVariables = {
  input: CreateItemInput,
  condition?: ModelItemConditionInput | null,
};

export type CreateItemMutation = {
  createItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateItemMutationVariables = {
  input: UpdateItemInput,
  condition?: ModelItemConditionInput | null,
};

export type UpdateItemMutation = {
  updateItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteItemMutationVariables = {
  input: DeleteItemInput,
  condition?: ModelItemConditionInput | null,
};

export type DeleteItemMutation = {
  deleteItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateEventMutationVariables = {
  input: CreateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type CreateEventMutation = {
  createEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateEventMutationVariables = {
  input: UpdateEventInput,
  condition?: ModelEventConditionInput | null,
};

export type UpdateEventMutation = {
  updateEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteEventMutationVariables = {
  input: DeleteEventInput,
  condition?: ModelEventConditionInput | null,
};

export type DeleteEventMutation = {
  deleteEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateNotificationMutationVariables = {
  input: CreateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type CreateNotificationMutation = {
  createNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateNotificationMutationVariables = {
  input: UpdateNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type UpdateNotificationMutation = {
  updateNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteNotificationMutationVariables = {
  input: DeleteNotificationInput,
  condition?: ModelNotificationConditionInput | null,
};

export type DeleteNotificationMutation = {
  deleteNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type CreateDocumentMutationVariables = {
  input: CreateDocumentInput,
  condition?: ModelDocumentConditionInput | null,
};

export type CreateDocumentMutation = {
  createDocument?:  {
    __typename: "Document",
    ownerId: string,
    id: string,
    docVersion: number,
    content: string,
    latestEditor: string,
    trashed?: boolean | null,
    archived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type UpdateDocumentMutationVariables = {
  input: UpdateDocumentInput,
  condition?: ModelDocumentConditionInput | null,
};

export type UpdateDocumentMutation = {
  updateDocument?:  {
    __typename: "Document",
    ownerId: string,
    id: string,
    docVersion: number,
    content: string,
    latestEditor: string,
    trashed?: boolean | null,
    archived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type DeleteDocumentMutationVariables = {
  input: DeleteDocumentInput,
  condition?: ModelDocumentConditionInput | null,
};

export type DeleteDocumentMutation = {
  deleteDocument?:  {
    __typename: "Document",
    ownerId: string,
    id: string,
    docVersion: number,
    content: string,
    latestEditor: string,
    trashed?: boolean | null,
    archived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type GetClientQueryVariables = {
  id: string,
};

export type GetClientQuery = {
  getClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListClientsQueryVariables = {
  id?: string | null,
  filter?: ModelClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListClientsQuery = {
  listClients?:  {
    __typename: "ModelClientConnection",
    items:  Array< {
      __typename: "Client",
      id: string,
      ownerUserId: string,
      name: string,
      slug: string,
      inviteLink?: string | null,
      userRole?: string | null,
      defaultWorkspaces?: string | null,
      meta: string,
      created_at?: string | null,
      customer_id?: string | null,
      subscription_plan?: string | null,
      subscription_status?: string | null,
      subscription_endsAt?: string | null,
      subscription_details?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncClientsQueryVariables = {
  filter?: ModelClientFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncClientsQuery = {
  syncClients?:  {
    __typename: "ModelClientConnection",
    items:  Array< {
      __typename: "Client",
      id: string,
      ownerUserId: string,
      name: string,
      slug: string,
      inviteLink?: string | null,
      userRole?: string | null,
      defaultWorkspaces?: string | null,
      meta: string,
      created_at?: string | null,
      customer_id?: string | null,
      subscription_plan?: string | null,
      subscription_status?: string | null,
      subscription_endsAt?: string | null,
      subscription_details?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetClientUserQueryVariables = {
  id: string,
};

export type GetClientUserQuery = {
  getClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListClientUsersQueryVariables = {
  id?: string | null,
  filter?: ModelClientUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListClientUsersQuery = {
  listClientUsers?:  {
    __typename: "ModelClientUserConnection",
    items:  Array< {
      __typename: "ClientUser",
      ownerId: string,
      id: string,
      email: string,
      sub: string,
      name?: string | null,
      surname?: string | null,
      isAdmin: boolean,
      isReadOnly: boolean,
      roles: string,
      roleUpdatedBy?: string | null,
      isConfirmed?: boolean | null,
      avatarPath?: string | null,
      closedAt?: string | null,
      lastActive?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncClientUsersQueryVariables = {
  filter?: ModelClientUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncClientUsersQuery = {
  syncClientUsers?:  {
    __typename: "ModelClientUserConnection",
    items:  Array< {
      __typename: "ClientUser",
      ownerId: string,
      id: string,
      email: string,
      sub: string,
      name?: string | null,
      surname?: string | null,
      isAdmin: boolean,
      isReadOnly: boolean,
      roles: string,
      roleUpdatedBy?: string | null,
      isConfirmed?: boolean | null,
      avatarPath?: string | null,
      closedAt?: string | null,
      lastActive?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ClientUserByEmailQueryVariables = {
  email: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClientUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ClientUserByEmailQuery = {
  clientUserByEmail?:  {
    __typename: "ModelClientUserConnection",
    items:  Array< {
      __typename: "ClientUser",
      ownerId: string,
      id: string,
      email: string,
      sub: string,
      name?: string | null,
      surname?: string | null,
      isAdmin: boolean,
      isReadOnly: boolean,
      roles: string,
      roleUpdatedBy?: string | null,
      isConfirmed?: boolean | null,
      avatarPath?: string | null,
      closedAt?: string | null,
      lastActive?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type ClientUserBySubQueryVariables = {
  sub: string,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelClientUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ClientUserBySubQuery = {
  clientUserBySub?:  {
    __typename: "ModelClientUserConnection",
    items:  Array< {
      __typename: "ClientUser",
      ownerId: string,
      id: string,
      email: string,
      sub: string,
      name?: string | null,
      surname?: string | null,
      isAdmin: boolean,
      isReadOnly: boolean,
      roles: string,
      roleUpdatedBy?: string | null,
      isConfirmed?: boolean | null,
      avatarPath?: string | null,
      closedAt?: string | null,
      lastActive?: string | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetClientUserInviteQueryVariables = {
  id: string,
};

export type GetClientUserInviteQuery = {
  getClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListClientUserInvitesQueryVariables = {
  id?: string | null,
  filter?: ModelClientUserInviteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListClientUserInvitesQuery = {
  listClientUserInvites?:  {
    __typename: "ModelClientUserInviteConnection",
    items:  Array< {
      __typename: "ClientUserInvite",
      ownerId: string,
      id: string,
      email: string,
      isAdmin: boolean,
      isReadOnly: boolean,
      roles: string,
      isInviteConfirmed: boolean,
      inviteLink: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncClientUserInvitesQueryVariables = {
  filter?: ModelClientUserInviteFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncClientUserInvitesQuery = {
  syncClientUserInvites?:  {
    __typename: "ModelClientUserInviteConnection",
    items:  Array< {
      __typename: "ClientUserInvite",
      ownerId: string,
      id: string,
      email: string,
      isAdmin: boolean,
      isReadOnly: boolean,
      roles: string,
      isInviteConfirmed: boolean,
      inviteLink: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkspaceQueryVariables = {
  id: string,
};

export type GetWorkspaceQuery = {
  getWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWorkspacesQueryVariables = {
  id?: string | null,
  filter?: ModelWorkspaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListWorkspacesQuery = {
  listWorkspaces?:  {
    __typename: "ModelWorkspaceConnection",
    items:  Array< {
      __typename: "Workspace",
      ownerId: string,
      id: string,
      name?: string | null,
      slug?: string | null,
      avatarPath?: string | null,
      childIds: string,
      archivedIds: string,
      trashedIds: string,
      pinnedIds?: string | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWorkspacesQueryVariables = {
  filter?: ModelWorkspaceFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWorkspacesQuery = {
  syncWorkspaces?:  {
    __typename: "ModelWorkspaceConnection",
    items:  Array< {
      __typename: "Workspace",
      ownerId: string,
      id: string,
      name?: string | null,
      slug?: string | null,
      avatarPath?: string | null,
      childIds: string,
      archivedIds: string,
      trashedIds: string,
      pinnedIds?: string | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetWorkspaceUserQueryVariables = {
  id: string,
};

export type GetWorkspaceUserQuery = {
  getWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListWorkspaceUsersQueryVariables = {
  filter?: ModelWorkspaceUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type ListWorkspaceUsersQuery = {
  listWorkspaceUsers?:  {
    __typename: "ModelWorkspaceUserConnection",
    items:  Array< {
      __typename: "WorkspaceUser",
      ownerId: string,
      workspaceId: string,
      userId: string,
      role: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      createdBy?: string | null,
      updatedBy?: string | null,
      id: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncWorkspaceUsersQueryVariables = {
  filter?: ModelWorkspaceUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncWorkspaceUsersQuery = {
  syncWorkspaceUsers?:  {
    __typename: "ModelWorkspaceUserConnection",
    items:  Array< {
      __typename: "WorkspaceUser",
      ownerId: string,
      workspaceId: string,
      userId: string,
      role: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      createdBy?: string | null,
      updatedBy?: string | null,
      id: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type WsUserByWsIdQueryVariables = {
  ownerId: string,
  workspaceIdUserId?: ModelWorkspaceUserByWorkspaceCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkspaceUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WsUserByWsIdQuery = {
  wsUserByWsId?:  {
    __typename: "ModelWorkspaceUserConnection",
    items:  Array< {
      __typename: "WorkspaceUser",
      ownerId: string,
      workspaceId: string,
      userId: string,
      role: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      createdBy?: string | null,
      updatedBy?: string | null,
      id: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type WsUserByUserIdQueryVariables = {
  ownerId: string,
  userId?: ModelIDKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelWorkspaceUserFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type WsUserByUserIdQuery = {
  wsUserByUserId?:  {
    __typename: "ModelWorkspaceUserConnection",
    items:  Array< {
      __typename: "WorkspaceUser",
      ownerId: string,
      workspaceId: string,
      userId: string,
      role: string,
      createdAt?: string | null,
      updatedAt?: string | null,
      createdBy?: string | null,
      updatedBy?: string | null,
      id: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetItemQueryVariables = {
  id: string,
};

export type GetItemQuery = {
  getItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListItemsQueryVariables = {
  id?: string | null,
  filter?: ModelItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListItemsQuery = {
  listItems?:  {
    __typename: "ModelItemConnection",
    items:  Array< {
      __typename: "Item",
      ownerId: string,
      workspaceId: string,
      id: string,
      name?: string | null,
      type: ItemType,
      childIds: string,
      parentIds: string,
      readRoles: string,
      writeRoles: string,
      creator: string,
      pinned?: boolean | null,
      trashed: boolean,
      archived: boolean,
      statusUpdatedBy?: string | null,
      ackUpdatedBy?: string | null,
      acknowledgementRequired?: boolean | null,
      acknowledgement?: string | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncItemsQueryVariables = {
  filter?: ModelItemFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncItemsQuery = {
  syncItems?:  {
    __typename: "ModelItemConnection",
    items:  Array< {
      __typename: "Item",
      ownerId: string,
      workspaceId: string,
      id: string,
      name?: string | null,
      type: ItemType,
      childIds: string,
      parentIds: string,
      readRoles: string,
      writeRoles: string,
      creator: string,
      pinned?: boolean | null,
      trashed: boolean,
      archived: boolean,
      statusUpdatedBy?: string | null,
      ackUpdatedBy?: string | null,
      acknowledgementRequired?: boolean | null,
      acknowledgement?: string | null,
      updatedAt: string,
      createdAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetEventQueryVariables = {
  id: string,
};

export type GetEventQuery = {
  getEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListEventsQueryVariables = {
  id?: string | null,
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListEventsQuery = {
  listEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      ownerId: string,
      workspaceId?: string | null,
      initiatorId?: string | null,
      type: string,
      meta: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncEventsQueryVariables = {
  filter?: ModelEventFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncEventsQuery = {
  syncEvents?:  {
    __typename: "ModelEventConnection",
    items:  Array< {
      __typename: "Event",
      id: string,
      ownerId: string,
      workspaceId?: string | null,
      initiatorId?: string | null,
      type: string,
      meta: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetNotificationQueryVariables = {
  id: string,
};

export type GetNotificationQuery = {
  getNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListNotificationsQueryVariables = {
  id?: string | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListNotificationsQuery = {
  listNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      ownerId: string,
      userId: string,
      eventId?: string | null,
      status?: string | null,
      channelAttempts?: string | null,
      initiatorId?: string | null,
      type: string,
      meta: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncNotificationsQueryVariables = {
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncNotificationsQuery = {
  syncNotifications?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      ownerId: string,
      userId: string,
      eventId?: string | null,
      status?: string | null,
      channelAttempts?: string | null,
      initiatorId?: string | null,
      type: string,
      meta: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type NotifByUserQueryVariables = {
  ownerId: string,
  userIdCreatedAt?: ModelNotificationByClientCompositeKeyConditionInput | null,
  sortDirection?: ModelSortDirection | null,
  filter?: ModelNotificationFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
};

export type NotifByUserQuery = {
  notifByUser?:  {
    __typename: "ModelNotificationConnection",
    items:  Array< {
      __typename: "Notification",
      id: string,
      ownerId: string,
      userId: string,
      eventId?: string | null,
      status?: string | null,
      channelAttempts?: string | null,
      initiatorId?: string | null,
      type: string,
      meta: string,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type GetDocumentQueryVariables = {
  id: string,
};

export type GetDocumentQuery = {
  getDocument?:  {
    __typename: "Document",
    ownerId: string,
    id: string,
    docVersion: number,
    content: string,
    latestEditor: string,
    trashed?: boolean | null,
    archived?: boolean | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type ListDocumentsQueryVariables = {
  id?: string | null,
  filter?: ModelDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  sortDirection?: ModelSortDirection | null,
};

export type ListDocumentsQuery = {
  listDocuments?:  {
    __typename: "ModelDocumentConnection",
    items:  Array< {
      __typename: "Document",
      ownerId: string,
      id: string,
      docVersion: number,
      content: string,
      latestEditor: string,
      trashed?: boolean | null,
      archived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SyncDocumentsQueryVariables = {
  filter?: ModelDocumentFilterInput | null,
  limit?: number | null,
  nextToken?: string | null,
  lastSync?: number | null,
};

export type SyncDocumentsQuery = {
  syncDocuments?:  {
    __typename: "ModelDocumentConnection",
    items:  Array< {
      __typename: "Document",
      ownerId: string,
      id: string,
      docVersion: number,
      content: string,
      latestEditor: string,
      trashed?: boolean | null,
      archived?: boolean | null,
      createdAt: string,
      updatedAt: string,
      _version: number,
      _deleted?: boolean | null,
      _lastChangedAt: number,
    } | null >,
    nextToken?: string | null,
    startedAt?: number | null,
  } | null,
};

export type SearchDocumentsQueryVariables = {
  filter?: SearchableDocumentFilterInput | null,
  sort?: Array< SearchableDocumentSortInput | null > | null,
  limit?: number | null,
  nextToken?: string | null,
  from?: number | null,
  aggregates?: Array< SearchableDocumentAggregationInput | null > | null,
};

export type SearchDocumentsQuery = {
  searchDocuments?:  {
    __typename: "SearchableDocumentConnection",
    items:  Array< {
      __typename: "SearchDocument",
      ownerId?: string | null,
      id?: string | null,
      itemId?: string | null,
      docVersion?: number | null,
      trashed?: boolean | null,
      archived?: boolean | null,
      highlight?:  {
        __typename: "Highlight",
        content?: Array< string | null > | null,
      } | null,
      latestEditor?: string | null,
    } | null >,
    nextToken?: string | null,
    total?: number | null,
    aggregateItems:  Array< {
      __typename: "SearchableAggregateResult",
      name: string,
      result: ( {
          __typename: "SearchableAggregateScalarResult",
          value: number,
        } | {
          __typename: "SearchableAggregateBucketResult",
          buckets?:  Array< {
            __typename: string,
            key: string,
            doc_count: number,
          } | null > | null,
        }
      ) | null,
    } | null >,
  } | null,
};

export type OnCreateClientSubscriptionVariables = {
  filter?: ModelSubscriptionClientFilterInput | null,
  id?: string | null,
};

export type OnCreateClientSubscription = {
  onCreateClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateClientSubscriptionVariables = {
  filter?: ModelSubscriptionClientFilterInput | null,
  id?: string | null,
};

export type OnUpdateClientSubscription = {
  onUpdateClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteClientSubscriptionVariables = {
  filter?: ModelSubscriptionClientFilterInput | null,
  id?: string | null,
};

export type OnDeleteClientSubscription = {
  onDeleteClient?:  {
    __typename: "Client",
    id: string,
    ownerUserId: string,
    name: string,
    slug: string,
    inviteLink?: string | null,
    userRole?: string | null,
    defaultWorkspaces?: string | null,
    meta: string,
    created_at?: string | null,
    customer_id?: string | null,
    subscription_plan?: string | null,
    subscription_status?: string | null,
    subscription_endsAt?: string | null,
    subscription_details?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateClientUserSubscriptionVariables = {
  filter?: ModelSubscriptionClientUserFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateClientUserSubscription = {
  onCreateClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateClientUserSubscriptionVariables = {
  filter?: ModelSubscriptionClientUserFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateClientUserSubscription = {
  onUpdateClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteClientUserSubscriptionVariables = {
  filter?: ModelSubscriptionClientUserFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteClientUserSubscription = {
  onDeleteClientUser?:  {
    __typename: "ClientUser",
    ownerId: string,
    id: string,
    email: string,
    sub: string,
    name?: string | null,
    surname?: string | null,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    roleUpdatedBy?: string | null,
    isConfirmed?: boolean | null,
    avatarPath?: string | null,
    closedAt?: string | null,
    lastActive?: string | null,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateClientUserInviteSubscriptionVariables = {
  filter?: ModelSubscriptionClientUserInviteFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateClientUserInviteSubscription = {
  onCreateClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateClientUserInviteSubscriptionVariables = {
  filter?: ModelSubscriptionClientUserInviteFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateClientUserInviteSubscription = {
  onUpdateClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteClientUserInviteSubscriptionVariables = {
  filter?: ModelSubscriptionClientUserInviteFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteClientUserInviteSubscription = {
  onDeleteClientUserInvite?:  {
    __typename: "ClientUserInvite",
    ownerId: string,
    id: string,
    email: string,
    isAdmin: boolean,
    isReadOnly: boolean,
    roles: string,
    isInviteConfirmed: boolean,
    inviteLink: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateWorkspaceSubscriptionVariables = {
  filter?: ModelSubscriptionWorkspaceFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateWorkspaceSubscription = {
  onCreateWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWorkspaceSubscriptionVariables = {
  filter?: ModelSubscriptionWorkspaceFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateWorkspaceSubscription = {
  onUpdateWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWorkspaceSubscriptionVariables = {
  filter?: ModelSubscriptionWorkspaceFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteWorkspaceSubscription = {
  onDeleteWorkspace?:  {
    __typename: "Workspace",
    ownerId: string,
    id: string,
    name?: string | null,
    slug?: string | null,
    avatarPath?: string | null,
    childIds: string,
    archivedIds: string,
    trashedIds: string,
    pinnedIds?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateWorkspaceUserSubscriptionVariables = {
  filter?: ModelSubscriptionWorkspaceUserFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateWorkspaceUserSubscription = {
  onCreateWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateWorkspaceUserSubscriptionVariables = {
  filter?: ModelSubscriptionWorkspaceUserFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateWorkspaceUserSubscription = {
  onUpdateWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteWorkspaceUserSubscriptionVariables = {
  filter?: ModelSubscriptionWorkspaceUserFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteWorkspaceUserSubscription = {
  onDeleteWorkspaceUser?:  {
    __typename: "WorkspaceUser",
    ownerId: string,
    workspaceId: string,
    userId: string,
    role: string,
    createdAt?: string | null,
    updatedAt?: string | null,
    createdBy?: string | null,
    updatedBy?: string | null,
    id: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateItemSubscriptionVariables = {
  filter?: ModelSubscriptionItemFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateItemSubscription = {
  onCreateItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateItemSubscriptionVariables = {
  filter?: ModelSubscriptionItemFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateItemSubscription = {
  onUpdateItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteItemSubscriptionVariables = {
  filter?: ModelSubscriptionItemFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteItemSubscription = {
  onDeleteItem?:  {
    __typename: "Item",
    ownerId: string,
    workspaceId: string,
    id: string,
    name?: string | null,
    type: ItemType,
    childIds: string,
    parentIds: string,
    readRoles: string,
    writeRoles: string,
    creator: string,
    pinned?: boolean | null,
    trashed: boolean,
    archived: boolean,
    statusUpdatedBy?: string | null,
    ackUpdatedBy?: string | null,
    acknowledgementRequired?: boolean | null,
    acknowledgement?: string | null,
    updatedAt: string,
    createdAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateEventSubscription = {
  onCreateEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateEventSubscription = {
  onUpdateEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteEventSubscriptionVariables = {
  filter?: ModelSubscriptionEventFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteEventSubscription = {
  onDeleteEvent?:  {
    __typename: "Event",
    id: string,
    ownerId: string,
    workspaceId?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnCreateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
  ownerId?: string | null,
};

export type OnCreateNotificationSubscription = {
  onCreateNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnUpdateNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
  ownerId?: string | null,
};

export type OnUpdateNotificationSubscription = {
  onUpdateNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};

export type OnDeleteNotificationSubscriptionVariables = {
  filter?: ModelSubscriptionNotificationFilterInput | null,
  ownerId?: string | null,
};

export type OnDeleteNotificationSubscription = {
  onDeleteNotification?:  {
    __typename: "Notification",
    id: string,
    ownerId: string,
    userId: string,
    eventId?: string | null,
    status?: string | null,
    channelAttempts?: string | null,
    initiatorId?: string | null,
    type: string,
    meta: string,
    createdAt: string,
    updatedAt: string,
    _version: number,
    _deleted?: boolean | null,
    _lastChangedAt: number,
  } | null,
};
